<template>
  <div class="inteldesk-home">
    <h2>Intel Desk</h2>
    <h4>
      Community-powered research driving the future of cryptocurrency analysis.
    </h4>
    <Button
      raised
      class="inteldesk-home__button --first"
      target="_blank"
      link="https://intel.bubblemaps.io"
    >
      Start Now
    </Button>
    <Button outlined class="inteldesk-home__button" route="/intel-desk">
      Read More
    </Button>
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <wistia-player
          media-id="iinaoahj30"
          seo="false"
          class="video-player"
          aspect="1.7777777777777777"
        ></wistia-player>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/atoms/material/Button.vue";

export default {
  name: "InteldeskHome",
  components: {
    Button,
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/variables";

.inteldesk-home {
  text-align: center;

  .inteldesk-home__button {
    margin-top: 20px;

    &.--first {
      margin-right: 10px;
    }
  }

  wistia-player[media-id="iinaoahj30"]:not(:defined) {
    background: center / contain no-repeat
      url("https://fast.wistia.com/embed/medias/iinaoahj30/swatch");
    display: block;
    filter: blur(5px);
    padding-top: 56.25%;
  }

  .video-player {
    max-width: 800px;
    margin: auto;
    margin-top: 50px;
  }
}
</style>
